export const OPEN_MENU = 'OPEN_MENU';
export const COLLAPSE_MENU = 'COLLAPSE_MENU';
